<template>
    <VDialog
            v-model="isReminderDialogOpen"
            persistent
            max-width="500px"
            transition="dialog-transition">
        <LoadingDialog ref="loading"/>
        <VCard>
            <VCardTitle class="headline pb-0">Criar lembrete</VCardTitle>
            <VCardText>
                <VForm ref="reminderForm">
                    <AutocompleteCliente v-model="novoLembrete.cliente"/>
                    <SelecaoData v-model="novoLembrete.data"/>
                    <VTextField prepend-icon="alarm" v-model="novoLembrete.hora" :mask="'##:##'" label="Hora" return-masked-value
                                  :rules="[rules.hora]"/>
                    <VTextarea
                            ref="descricao"
                            v-model="novoLembrete.descricao"
                            label="Descrição"
                            :rules="[rules.obrigatorio()]"
                    />
                </VForm>
            </VCardText>
            <VCardActions>
                <VSpacer/>
                <VBtn flat @click="cancelarForm">Cancelar</VBtn>
                <VBtn color="primary"
                      @click="salvar">Adicionar</VBtn>
            </VCardActions>
        </VCard>
    </VDialog>
</template>

<script>
    import ApiService from "@/common/api.service";
    import LoadingDialog from '@/components/Dialog/Loading';
    import moment from "moment";
    import {mapState} from "vuex";
    import alerts from '@/common/alerts';
    import eventos from '@/common/eventos';
    import forms from '@/common/forms'
    import SelecaoData from "../SelecaoData";
    import AutocompleteCliente from "../AutocompleteCliente";

    export default {
        components: {
            LoadingDialog, SelecaoData, AutocompleteCliente
        },
        props: {
            value: {type: Boolean, default: false}
        },
        data() {
            return {
                isReminderDialogOpen: false,
                novoLembrete: {
                    cliente: null,
                    data: null,
                    hora: null,
                    descricao: null
                },
                clientes: [],
                rules: forms.rules
            };
        },
        computed: {
            ...mapState(["dataAtual"])
        },
        watch: {
            isReminderDialogOpen(aberto) {
                if (aberto) {
                    this.novoLembrete = {
                        cliente: null,
                        data: this.dataAtual,
                        hora: null,
                        descricao: null
                    };
                    this.$refs.reminderForm.resetValidation();
                }
                this.$emit("input", aberto);
            },
            value(aberto){
                this.isReminderDialogOpen = aberto;
            }
        },
        methods: {
            selecionaCliente() {
                this.form.cliente = this.cliente;
            }
            ,
            cancelarForm() {
                this.isReminderDialogOpen = false;
            }
            ,
            async salvar() {
                if (!this.$refs.reminderForm.validate()) {
                    return;
                }
                let hora = moment(this.novoLembrete.hora, 'LT');
                let dia = moment(this.novoLembrete.data);
                let lembrete = {
                    idCliente: this.novoLembrete.cliente ? this.novoLembrete.cliente.id : null,
                    descricao: this.novoLembrete.descricao,
                    data: dia.set({
                        hour: hora.get('hour'),
                        minute: hora.get('minute'),
                        second: 0,
                        millisecond: 0
                    }).format()
                };
                try {
                    await this.$refs.loading.aguardarPromises([ApiService.post("lembretes", lembrete)]);
                    eventos.barramento.$emit(eventos.LEMBRETE_CRIADO);
                    this.isReminderDialogOpen = false;
                } catch (e) {
                    alerts.exibirErro('Não foi possível salvar o lembrete', e);
                }
            }
        }
    };
</script>
